export default {
  LIST_FETCHED: 'PROFILE_FETCHED',
  LIST_LOAD: 'PROFILE_LOAD',
  ITEM_DETAIL: 'PROFILE_DETAIL',
  BUTTON_LOAD: 'PROFILE_BUTTON_LOAD',
  PAGARME_DATA_LOAD: 'PAGARME_DATA_LOAD',
  PAGARME_DATA_FETCHED: 'PAGARME_DATA_FETCHED',
  PAYMENT_LINK_LOAD: 'PAYMENT_LINK_LOAD',
  PAYMENT_LINK_FETCHED: 'PAYMENT_LINK_FETCHED',
};
